import React, { Component } from 'react';
//import clsx from 'clsx';
// import PropTypes from 'prop-types';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import { Field, reduxForm } from 'redux-form';
import { Grid, Button, withStyles } from '@material-ui/core';
import RenderTextFieldRedux from './../Complements/RenderTextFieldRedux';
import RenderDecimalTextField from '../Complements/renderDecimalTextFiel';
import renderCheckbox from '../Complements/renderCheckbox';
import CssBaseline from '@material-ui/core/CssBaseline';


const validate = values => {
    const error = {}
    if (!values.cedule) {
        error.cedule = "La cédula es requerida"
    }
    if (!values.cellphone) {
        error.cellphone = "El teléfono es un campo obligatorio"
    }
    if (!values.number) {
        error.number = "La número de cuenta es un campo obligatorio"
    }
    if (!values.email) {
        error.email = "El correo electrónico es un campo obligatorio"
    }
    return error
}

const useStyles = theme => ({
    buttonStandard: {
        fontSize: '1rem',
        color: '#ffffff',
        borderRadius: '4px',
        '&.Mui-disabled': {
            backgroundColor: "#a7a8a8",
        },
        '&:hover': {
            backgroundColor: "#706D85",
        },
        backgroundColor: "#2E2757",
        //fontFamily: 'MyriadPro-Bold',
    },
});

class UserRegisterForm extends Component {
    state = {
        Radiogroup: [
            {
                id: 1,
                value: 'CLIENTE',
                label: 'Cliente'
            },
            {
                id: 2,
                value: 'OPERATIVO',
                label: 'Operativo'
            }
        ],
    }
    render() {
        const { classes, handleSubmit, valid, submitting, cancelPrompt, cedule, activeStep, type, findCustomer } = this.props;
        return (
            <React.Fragment>
                <CssBaseline />
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                            <Field
                                {...this.state}
                                withFocus
                                name="type"
                                id="type"
                                required
                                defaultValue={type}
                                changeData={this.handleChange}
                                /* className={clsx(classes.margin, classes.textField)} */
                                component={renderCheckbox}
                                label="Tipo de usuario"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                withFocus
                                name="cedule"
                                id="cedule"
                                required
                                valueData={cedule}
                                /* className={clsx(classes.margin, classes.textField)} */
                                component={RenderDecimalTextField}
                                label="Cédula"
                                type="text"
                                changeData={
                                    value => (value.length === 10 || value.length === 13) && findCustomer(value)
                                }
                                fullWidth
                                allowZero={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                withFocus
                                name="owner"
                                id="owner"
                                required
                                /* className={clsx(classes.margin, classes.textField)} */
                                component={RenderTextFieldRedux}
                                label="Propietario"
                                type="text"
                                disabled
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                withFocus
                                name="number"
                                id="number"
                                required
                                /* className={clsx(classes.margin, classes.textField)} */
                                component={RenderTextFieldRedux}
                                label="Número de cuenta"
                                type="text"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                withFocus
                                name="email"
                                id="email"
                                required
                                allowZero={true}
                                /* className={clsx(classes.margin, classes.textField)} */
                                component={RenderTextFieldRedux}
                                label="Correo electrónico"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                withFocus
                                name="cellphone"
                                id="cellphone"
                                required
                                // valueData = { cellphone}
                                allowZero={true}
                                /* className={clsx(classes.margin, classes.textField)} */
                                component={RenderDecimalTextField}
                                label="Número de teléfono"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={6} md={6} lg={6}>
                            <Button variant="contained" onClick={cancelPrompt} className={classes.buttonStandard} disabled={activeStep === 0}>
                                Atrás
                            </Button>
                        </Grid>
                        <Grid item xs={6} md={6} lg={6}>
                            <Button variant="contained" type="submit"
                                disabled={!valid || submitting} className={classes.buttonStandard}>
                                Siguiente
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </React.Fragment>
        );
    }
}

UserRegisterForm.propTypes = {

};

const UserRegisterReduxForm = reduxForm(
    {
        form: 'UserRegisterForm',
        validate
    }
)(UserRegisterForm)

// export default UserRegisterForm;
export default setPropsAsInitial(withStyles(useStyles)(UserRegisterReduxForm))